import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const UnitDetail = lazy(() =>
  componentLoader(() => import("./components/UnitDetail")),
);

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <UnitDetail />
      </section>
    </Suspense>
  </div>
);
